import React from 'react';
import { Card, useIsMobile } from '../components/ui';
import PageLayout from '../components/layout/PageLayout';

const S = {
  h2: { fontSize: '16px', fontWeight: 700, color: 'var(--gray-900)', marginTop: '26px', marginBottom: '10px' },
  p: { fontSize: '13.5px', color: 'var(--gray-600)', lineHeight: 1.7, marginBottom: '10px' },
  li: { fontSize: '13.5px', color: 'var(--gray-600)', lineHeight: 1.7, marginBottom: '6px' },
};

export default function Terms() {
  const isMobile = useIsMobile();
  return (
    <PageLayout>
      <div style={{ maxWidth: '760px', margin: '0 auto', padding: isMobile ? '0' : '8px 0' }}>
        <h1 style={{ fontSize: '26px', fontWeight: 800, letterSpacing: '-0.03em', color: 'var(--gray-900)', marginBottom: '4px' }}>
          Terms of Service
        </h1>
        <p style={{ fontSize: '12.5px', color: 'var(--gray-400)', marginBottom: '24px' }}>Last updated: July 2026</p>

        <Card>
          <div style={{
            padding: '13px 16px', borderRadius: '10px', background: 'var(--red-light)',
            border: '1px solid var(--red-mid)', marginBottom: '20px',
          }}>
            <p style={{ ...S.p, marginBottom: 0, color: 'var(--red-dark)', fontWeight: 600 }}>
              HopeForSomeone connects donors, recipients, and organizations — it is not a hospital, blood bank,
              or emergency service. In a medical emergency, always contact local emergency services first.
            </p>
          </div>

          <div style={S.h2}>What this platform is</div>
          <p style={S.p}>HopeForSomeone is a free coordination platform. We help recipients and organizations
            reach eligible donors, and we help donors find requests and camps near them. We don't collect,
            store, transport, or handle blood or medical supplies, and we don't perform or supervise donations
            — that happens at hospitals, blood banks, and camps run by the organizations on this platform.</p>

          <div style={S.h2}>Eligibility &amp; accounts</div>
          <ul style={{ paddingLeft: '20px', marginBottom: '10px' }}>
            <li style={S.li}>You must provide accurate information when registering, posting a request, or
              answering health screening questions. Donation eligibility is based on your own answers — we don't
              independently verify them, and ultimate fitness to donate is determined by the camp or facility
              where you donate.</li>
            <li style={S.li}>Donors must be between 18 and 65 years old.</li>
            <li style={S.li}>Organizations must provide truthful registration details and are reviewed by an
              admin before they can list donation camps.</li>
            <li style={S.li}>You're responsible for keeping your login credentials to yourself.</li>
          </ul>

          <div style={S.h2}>What we don't guarantee</div>
          <ul style={{ paddingLeft: '20px', marginBottom: '10px' }}>
            <li style={S.li}>That any donor will see, accept, or respond to a specific request.</li>
            <li style={S.li}>That a donor who accepts a request will ultimately be eligible to donate once
              screened in person, or that they'll show up.</li>
            <li style={S.li}>Uninterrupted, error-free access to the platform at all times.</li>
          </ul>
          <p style={S.p}>Use it as one tool among several when you urgently need blood — not the only one.</p>

          <div style={S.h2}>Acceptable use</div>
          <p style={S.p}>Don't use HopeForSomeone to post false or exaggerated requests, harass other users,
            misuse contact information shared with you, impersonate a hospital or organization, or attempt to
            circumvent rate limits or verification requirements. We may suspend or deactivate accounts that
            violate this.</p>

          <div style={S.h2}>Liability</div>
          <p style={S.p}>HopeForSomeone is provided free and "as is." We're a coordination layer, not a medical
            provider, and we're not liable for the outcome of any donation, medical decision, or interaction
            between users that happens off the platform.</p>

          <div style={S.h2}>Changes</div>
          <p style={S.p}>We may update these terms as the platform evolves. Material changes will be reflected
            here with an updated date at the top of this page.</p>

          <div style={S.h2}>Contact</div>
          <p style={S.p}>
            Questions about these terms: <a href="mailto:hello@hopeforsomeone.com" style={{ color: 'var(--red)', fontWeight: 600 }}>hello@hopeforsomeone.com</a>
          </p>
        </Card>
      </div>
    </PageLayout>
  );
}
